.messageContainer {
  display: flex;
  flex-flow: row wrap;

  &.outgoingContainer {
    justify-content: flex-end;
  }

  &.incomingContainer {
    justify-content: flex-start;
  }
}
